import { getShorterString } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';

const Title = ({ action, brandName, title }) => {
  switch (action) {
    case 'articleCreated':
      return <span>{getShorterString(title, 50)}</span>;
    case 'audioCreated':
      return <span>{getShorterString(title, 50)}</span>;
    case 'videoCreated':
      return <span>{getShorterString(title, 50)}</span>;
    case 'subscribedToBrand':
      return (
        <span>
          Je volgt nu <b>{brandName}</b>
        </span>
      );
    case 'subscribedToFirstBrand':
      return (
        <span>
          Hier krijg je updates gebaseerd op de titels die jij volgt. Klik hier
          voor meer info over notificaties en volgen.
        </span>
      );
    default:
      return null;
  }
};

Title.propTypes = {
  title: PropTypes.string,
  action: PropTypes.string.isRequired,
  brandName: PropTypes.string,
};

export { Title };
